import { type JSX, Show } from 'solid-js';

// A loud state's reason inside its status region (#6785). The region announces
// `liveReason`, which holds still across polls; where the shown reason ticks (Offline's
// "Last seen <ago>"), the shown words are hidden from assistive tech and the steady
// sentence is read instead, so a 20-second poll never re-announces the card.

export function LiveReason(props: {
  readonly reason: string;
  readonly liveReason: string;
  readonly class: string;
}): JSX.Element {
  return (
    <Show
      when={props.reason !== props.liveReason}
      fallback={
        <span class={props.class} title={props.reason}>
          {props.reason}
        </span>
      }
    >
      <span class={props.class} aria-hidden="true" title={props.reason}>
        {props.reason}
      </span>
      <span class="sr-only">{props.liveReason}</span>
    </Show>
  );
}
